import { FirstPlaceList, MultiraceSelectBetDataList } from '@/modelTypes';

import { MultiraceProgram, MultiraceType } from '../apollo/types/gen/graphql';

export const getMultiraceTypeName = (type?: MultiraceType) => {
  switch (type) {
    case MultiraceType.Chariloto: {
      return 'チャリロト';
    }
    case MultiraceType.Chariloto3: {
      return 'チャリロト3';
    }
    case MultiraceType.Chariloto5: {
      return 'チャリロト5';
    }
    case MultiraceType.CharilotoSelect: {
      return 'チャリロトセレクト';
    }
    case MultiraceType.Dokanto4two: {
      return 'Dokanto!4two';
    }
    case MultiraceType.Dokanto7: {
      return 'Dokanto!7';
    }
    default: {
      return '';
    }
  }
};

// 買い目データから欠車車番が含まれているものを削除する
export const filterInvalidBetDataMulti = (
  raceData: MultiraceProgram,
  prevBetData: MultiraceSelectBetDataList,
  notReleasedEntryRacersList: number[][],
): MultiraceSelectBetDataList => {
  const temp = { ...prevBetData };
  const targetData = temp[raceData.id];
  const checkList: boolean[] = [];
  Object.entries(targetData).forEach(([key, value]) => {
    const beforeTicketsLength = value.tickets.length;
    const availableTickets = value.tickets.filter(ticket =>
      ticket.every((num, i) =>
        notReleasedEntryRacersList[i].every(n => num !== n),
      ),
    );

    if (availableTickets.length) {
      targetData[key].tickets = availableTickets;

      const filterdFirstPlaceList = raceData.targetRaceNumbers.reduce(
        (acc, targetNum, i) => {
          const filterdList = value.firstPlaceList[targetNum].filter(betNum =>
            notReleasedEntryRacersList[i].every(n => betNum !== n),
          );
          return {
            ...acc,
            [targetNum]: filterdList,
          };
        },
        {},
      ) as FirstPlaceList;
      targetData[key].firstPlaceList = filterdFirstPlaceList;
    } else {
      delete targetData[key];
    }
    checkList.push(availableTickets.length === beforeTicketsLength);
  });

  // 対象レースの買い目が全て削除になったとき対象レースの買い目データは削除
  if (!Object.keys(targetData).length) {
    delete temp[raceData.id];
    return temp;
  }

  // 欠車車番を含む買い目が合ったときは対象を削除して更新
  if (checkList.some(x => !x)) {
    return temp;
  }

  // 買い目に変更がなかったときは元データを返却
  return prevBetData;
};

export const orderByMultiraceType = (
  mps: MultiraceProgram[],
): MultiraceProgram[] => {
  const programs = [] as MultiraceProgram[];
  [
    MultiraceType.Chariloto,
    MultiraceType.CharilotoSelect,
    MultiraceType.Chariloto5,
    MultiraceType.Chariloto3,
    MultiraceType.Dokanto7,
    MultiraceType.Dokanto4two,
  ].forEach(type => {
    const target = mps.find(mp => mp.multiraceType === type);
    if (target) {
      programs.push(target);
    }
  });
  return programs;
};
